import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
export var convertBreakpointToResponsive = function convertBreakpointToResponsive(breakpoints) {
  return _objectSpread(_objectSpread({}, breakpoints), {}, {
    mobile: breakpoints.xs,
    tablet: breakpoints.md,
    laptop: breakpoints.lg,
    desktop: breakpoints.xxl
  });
};